var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2639 11.9823L19.949 4.35018C20.0666 4.21118 19.9677 4.00001 19.786 4.00001H17.6538C17.5283 4.00001 17.408 4.05614 17.3252 4.15237L11.8691 10.3197L6.72255 4.15236C6.64239 4.05613 6.52215 4 6.3939 4H4.26171C4.08002 4 3.98116 4.21117 4.09872 4.35017L10.4744 11.9823L4.05063 19.6498C4.0243 19.6808 4.0074 19.7187 4.00195 19.759C3.9965 19.7993 4.00273 19.8403 4.01989 19.8772C4.03705 19.9141 4.06442 19.9452 4.09876 19.967C4.1331 19.9888 4.17297 20.0002 4.21362 20H6.34581C6.47139 20 6.59163 19.9439 6.67446 19.8476L11.8691 13.645L17.3252 19.8146C17.4053 19.9109 17.5256 19.967 17.6538 19.967H19.786C19.9677 19.967 20.0666 19.7558 19.949 19.6168L13.2639 11.9823Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseOutlined);
export default __webpack_public_path__ + "static/media/close_outlined.e64dc9f0351c555b24712627d110ad0d.svg";
export { ForwardRef as ReactComponent };